import { SideNav as BaseSideNav } from '@/components';
import { abilityConstants, userCan } from '@/lib';
import { userSelector } from '@/redux/auth';
import { memo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

const {
  ACCESS_ASPYN_MIGRATOR_ABILITY,
} = abilityConstants;

const SideNav = () => {
  const location = useLocation();
  const user = useSelector(userSelector);
  const items = ([
    {
      name: 'Jobs',
      path: '/aspyn-migrator',
      ability: ACCESS_ASPYN_MIGRATOR_ABILITY,
    },
    {
      name: 'Settings',
      path: '/aspyn-migrator/settings',
      ability: ACCESS_ASPYN_MIGRATOR_ABILITY,
    },
  ])
    .filter(({ ability }) => userCan(user, ability))
    .map((item) => Object.assign(item, { active: item.path === location.pathname }));

  return (
    <BaseSideNav items={items} />
  );
};

export default memo(SideNav);
